import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { ConfigProvider, theme as antTheme } from 'antd';
import { themeConfig } from '@/shared/theme';

export type ThemeContextType = {
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
};

export const ThemeContext = createContext<ThemeContextType>(
  {} as ThemeContextType,
);

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState<ThemeContextType['theme']>('light');
  const { defaultAlgorithm, darkAlgorithm } = antTheme;

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <ConfigProvider
        theme={{
          algorithm: theme === 'dark' ? darkAlgorithm : defaultAlgorithm,
          token: {
            colorPrimary: themeConfig[theme!].colors.primary,
            colorError: themeConfig[theme!].colors.error,
            colorLink: themeConfig[theme!].colors.primary,
            colorTextBase: themeConfig[theme!].colors.text,
            colorBgBase: themeConfig[theme!].colors.layoutBg,
            colorBorder: themeConfig[theme!].colors.componentBorder,
            colorText: themeConfig[theme!].colors.text,
            colorPrimaryBg: themeConfig[theme!].colors.colorPrimaryBg,
            colorTextPlaceholder: themeConfig[theme!].colors.text + '80',
            colorTextDisabled: themeConfig[theme!].colors.text + '80',
            colorSplit: themeConfig[theme!].colors.componentBorder + '80',
          },
          components: {
            Tooltip: {
              fontSize: 12,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
